<div mat-dialog-title>
  <ng-container i18n="@@profileView.headlineDialog.title">{title, select,
    other {{{ title }}}
  }</ng-container>
</div>
<mat-dialog-content>
  <div class="u-marginBottom-16">
    <ng-container
      i18n="@@profileView.headlineDialog.description"
      >{description, select, other {{{ description }}}
    }</ng-container>
  </div>
  <app-profile-form-headline
    class="u-display-block"
    [user]="user"
    (formChange)="formChange($event)"
  >
  </app-profile-form-headline>
</mat-dialog-content>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
  <div class="u-marginRight-8">
    <button i18n="@@global.cancel" mat-button [mat-dialog-close]>Cancel</button>
  </div>
  <button
    mat-raised-button
    color="primary"
    (click)="save(update, user)"
    [disabled]="isLoading"
  >
    <i
      *ngIf="isLoading"
      nz-icon
      nzType="sync"
      nzTheme="outline"
      nzSpin
      class="u-marginRight-8"
    ></i>
    <span i18n="@@global.save">Save</span>
  </button>
</div>
